import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function PricingSection() {
  const [dayName, setDayName] = useState('HOY');
  useEffect(() => {
    const day = new Date().toLocaleDateString('es-AR', {
      weekday: 'long'
    });
    setDayName(day.toUpperCase());
  }, []);
  return <section className="py-12 md:py-16 px-4 md:px-6 lg:px-8 bg-black" data-id="element-145">
      <div className="max-w-3xl mx-auto text-center" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-white/10 relative overflow-hidden" data-id="element-147">
          {/* Mockup Placeholder */}
          <div className="w-full max-w-sm mx-auto mb-6" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/4urvcCGMNcreEMGzNkatxR/Mockup_Oferta.png" alt="Renovación Sin Obras — Sistema Completo" className="w-full h-auto rounded-lg" data-id="element-149" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-black tracking-tight mb-2" data-id="element-150">
            Renovación Sin Obras
          </h2>

          <p className="text-base md:text-lg text-black/70 italic font-medium mb-6" data-id="element-151">
            "El Sistema Práctico para Transformar Cualquier Ambiente en 4 Horas
            Sin Demolición ni Suciedad"
          </p>

          {/* Premium Pills */}
          <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-152">
            <div className="flex flex-col items-center justify-center bg-[#1a1a1a] rounded-xl border border-white/10 py-5 px-3" data-id="element-153">
              <span className="text-orange font-black text-3xl md:text-4xl leading-none mb-2" data-id="element-154">
                +50
              </span>
              <span className="text-white text-[10px] md:text-xs font-bold uppercase tracking-wider text-center leading-tight" data-id="element-155">
                Soluciones
                <br data-id="element-156" />
                Prácticas
              </span>
            </div>
            <div className="flex flex-col items-center justify-center bg-[#1a1a1a] rounded-xl border border-white/10 py-5 px-3" data-id="element-157">
              <span className="text-orange font-black text-3xl md:text-4xl leading-none mb-2" data-id="element-158">
                4hs
              </span>
              <span className="text-white text-[10px] md:text-xs font-bold uppercase tracking-wider text-center leading-tight" data-id="element-159">
                Para
                <br data-id="element-160" />
                Remodelar
              </span>
            </div>
            <div className="flex flex-col items-center justify-center bg-[#1a1a1a] rounded-xl border border-white/10 py-5 px-3" data-id="element-161">
              <span className="text-orange font-black text-3xl md:text-4xl leading-none mb-2" data-id="element-162">
                $0
              </span>
              <span className="text-white text-[10px] md:text-xs font-bold uppercase tracking-wider text-center leading-tight" data-id="element-163">
                En
                <br data-id="element-164" />
                Obreros
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center mb-6" data-id="element-165">
            <span className="text-black/50 font-bold mb-1 uppercase tracking-wider text-xs" data-id="element-166">
              Precio de Oferta:
            </span>
            <span className="text-black/40 line-through text-xl font-bold mb-1" data-id="element-167">
              <PriceDisplay amount={65990} data-id="element-168" />
            </span>
            <div className="flex items-start text-orange font-black leading-none" data-id="element-169">
              <span className="text-5xl md:text-6xl tracking-tighter" data-id="element-170">
                <PriceDisplay amount={19990} data-id="element-171" />
              </span>
            </div>
          </div>

          <a href="https://bibliadigital.myshopify.com//cart/add?id=47688902443165&quantity=1" onClick={() => {
          if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
        }} className="block w-full bg-orange text-white font-black text-xl py-4 rounded-lg shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300 ease-out mb-4 uppercase tracking-wide" data-id="element-172">
            QUIERO MI RENOVACIÓN
          </a>

          <p className="text-black font-bold mb-4 text-sm" data-id="element-173">
            Pago Único. Sin Cargos Mensuales
          </p>
        </motion.div>
      </div>
    </section>;
}